var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"snow",staticClass:"fixed left-0 top-0 w-screen h-screen bg-gray-900/10 dark:bg-transparent z-80000 pointer-events-none"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }